import { render, staticRenderFns } from "./IconsChat.vue?vue&type=template&id=04c22deb&scoped=true&"
import script from "./IconsChat.vue?vue&type=script&lang=js&"
export * from "./IconsChat.vue?vue&type=script&lang=js&"
import style0 from "./IconsChat.vue?vue&type=style&index=0&id=04c22deb&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c22deb",
  null
  
)

export default component.exports